<template>
    <div class="multi-line-chart">
        <div id="popup" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h3>{{hoveredNode['nombre_'+dimensions.time[0]]}}</h3>
                <div class="amount">{{moneyFormatter(hoveredNode.sum)}}</div>
            </div>
        </div>
        <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
            <g :transform="'translate('+margin.left+','+margin.top+')'">
                <g class="axis">
                    <g ref="yAxis"></g>
                    <g ref="xAxis" :transform="'translate(0,'+chartHeight+')'"></g>
                </g>

                <g v-for="(d,key) in data" class="metric">
                    <path :d="line(d)" fill="none" :stroke="color(key)" stroke-width="4"></path>
                    <circle v-for="c in d" r="5" :cx="x(c.mes)" :cy="y(c.sum)" style="cursor: pointer" @mouseenter="hoveredNode = c" v-tippy="{html: '#popup', followCursor: true, arrow: true, animation: 'fade'}"></circle>
                </g>
                <!--
                <g v-for="d in data">
                    <title>{{d[dimensions.time[0]]}}: {{d.sum}}</title>
                    <rect :y="y(d.sum)" :height="chartHeight - y(d.sum)" :x="x(d[dimensions.time[0]])" :width="x.bandwidth()" :fill="color(d[dimensions.time[0]])"></rect>
                </g>
                -->
            </g>
        </svg>
        <div>
            <ul class="legend">
                <li v-for="(l,key) in labels">
                    <span class="key" :style="{background: color(key)}"></span>
                    <span>{{l}}</span>
                </li>
            </ul>
        </div>
    </div>

</template>
<style lang="scss">
    .multi-line-chart{
        ul.legend{
            list-style:none;
            background: #F7F7F7;
            padding: 20px;
            font-size: 10px;
            font-weight: 500;
            text-transform: uppercase;
            >li{
                margin-right: 20px;
                display: inline-block;
                .key{
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    border-radius: 6px;
                    background: black;
                    margin-right: 5px;
                }
            }
        }
        svg{
            width: 100%;
            height: auto;
            .axis{
                .domain{
                    display: none;
                }
                .tick{
                    line{
                        stroke: #D6D5D5;
                    }
                    text{
                        font-size: 10px;
                        text-transform: uppercase;
                    }

                    &:first-of-type{
                        line{
                            stroke: #979797;
                            stroke-width: 4px;
                        }

                    }

                }
            }
        }
    }
</style>
<script>
    import * as d3 from 'd3';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter';
    import moment from 'moment';

    export default{
        data: function(){
            return {
                margin:{
                    left: 100,
                    top: 20,
                    right: 40,
                    bottom: 20
                },
                hoveredNode: null
            }
        },
        props:{
            data: {},
            labels: {},
            dimensions: {},
            width: {default: 825},
            height: {default: 510}
        },
        methods:{
            numeral: numeral,
            moneyFormatter: moneyFormatter
        },
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            x: function(){
                return d3.scaleLinear()
                    .range([0, this.chartWidth])
                    .domain([
                        d3.min(this.data, (array)=>{return d3.min(array, (d)=>{return d[this.dimensions.time[0]]})}),
                        d3.max(this.data, (array)=>{return d3.max(array, (d)=>{return d[this.dimensions.time[0]]})})
                    ]);
            },
            y: function(){
                return d3.scaleLinear()
                    .range([this.chartHeight, 0])
                    .domain([0, d3.max(this.data, (array)=>{return d3.max(array, (d)=>{return d.sum})})]);
            },
            line: function(){
                return d3.line()
                    .curve(d3.curveMonotoneX)
                    .x((d) => { return this.x(d[this.dimensions.time[0]]); })
                    .y((d) => { return this.y(d.sum); });
            },
            color: function(){
                return d3.scaleOrdinal(['#459FED','#99C24D','#EF476F']);
            },
            axisLeft: function(){
                return d3.axisLeft(this.y)
                    .tickSize(-this.width)
                    .tickPadding(10)
                    .tickFormat((d)=>{
                        return numeral(d).format('0,0');
                    });
            },
            axisBottom: function(){
                return d3.axisBottom(this.x)
                    .tickSize(-this.height)
                    .tickPadding(10)
                    .ticks(d3.max(this.data, function(array){return array.length}))
                    .tickFormat((d)=>{
                        return moment(d, 'M').format('MMMM');
                    });
            }
        },
        watch:{
            data: function(){
                d3.select(this.$refs.yAxis).call(this.axisLeft);
                d3.select(this.$refs.xAxis).call(this.axisBottom);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/MultiLine.vue